export const dark = {
  primary: '#202022',
  secondary: '#e5e4e8',
  light: '#e5e4e8',
  lightgrey: '#acacac',
  skyblue: '#1586d9',
  deepdarkgrey: '#2a2d33',
  deepergrey: '#19191b',
  orange200: '#F7D8C3',
  orange400: '#E69B69',
  orange800: '#613114',
  blue100: '#E0E3FF',
  blue200: '#B8BEFF',
  blue500: '#1327FF',
  blue900: '#000752',
  green200: '#CEF5EB',
  green300: '#AFE9DA',
  green500: '#60D2B6',
  yellow200: '#FFF6C2',
}

// new light theme
export const light = {
  primary: '#0A0AE9',
  primaryHover: '#5C69FF',
  lightblue: '#CCD0FF',
  focus: '#CCD0FF',

  blue100: '#858FFF',
  blue200: '#5C69FF',
  dark200: '#7A7A99',
  dark300: '#58587A',
  dark600: '#B4B4CC',
  dark700: '#8989A3',
  dark800: '#545469',
  dark900: '#1B1B33',
  modalBackground: 'rgba(27, 27, 51, .4)',
  mint100: '#E0F9F2',
  gray100: '#FAFAFC', // almost white
  gray200: '#F5F5F7',
  gray300: '#EDEDF2',
  gray350: '#EEEEF4',
  gray400: '#E4E4EB',
  gray500: '#D0D0D6',
  gray900: '#58587A',
  greenAlert: '#DCF9F6',
  green100: '#188C7E',
  green200: '#12695F',
  green300: '#0F574F',
  green500: '#60D2B6',
  green600: '#36BF9D',
  orange100: '#FDF0EC',
  orange200: '#ee4f26',
  orange300: '#D03711',
  purple: '#61057F',
  redFocus: 'rgba(245, 204, 207, .9)',
  redAlert: 'rgba(245, 204, 207, .5)',
  red100: '#DD5560',
  red200: '#CC2936',
  red300: '#BB2532',
  red400: '#FF475A',
  red500: '#FF122A',
  red800: '#7A000C',
  teal: '#0BF9F2',
  transparent: 'transparent',
}

export const dimensions = {
  topNavHeight: 94,
  sidebarWidth: 352,
  vscrollWidth: '0.5em',
  profileHeight: '30px',
  tabbarHeight: '70px',
  navHeight: '40px',
  contentMaxWidth: '960px',
  chatTitleHeight: '45px',
  chatInputHeight: '60px',
  modalSidePanelWidth: '200px',
  borderRadiusXS: '4px',
  borderRadiusSM: '6px',
  xxBorderRadiusSM: '8px', // this is the border radius matching the new designs. When we complete the migration, we can remove this and rename borderRadiusSM to borderRadiusSM
  borderRadiusMD: '12px',
  borderRadiusLG: '24px',
  borderRadiusCircle: '50%',
}

export const spacing = {
  XS: '2px',
  spacingSM: '4px',
  spacingMD: '8px',
  spacingLG: '12px',
  spacingXL: '16px',
  spacingXXL: '20px',
  spacingXXXL: '24px',
}
